import FormatDateTime from 'components/utils/Formatters/FormatDateTime'
import HighlightLabel from 'LuxKit/Label/HighlightLabel'
import { useIntl } from 'react-intl'
import type { ReactNode } from 'react'
import { useEffect, useState } from 'react'
import { diffInDays } from 'lib/datetime/dateUtils'

interface Props {
  endsAt?: Date
  mode: 'countdown' | 'until'
}

function LoyaltyChooseDoubleRewardsLandingPageActiveLabel({ endsAt, mode }: Props) {
  const intl = useIntl()
  const [days, setDays] = useState<number>()

  // Run when either changes (re-render if endAt loads in)
  useEffect(() => {
    if (endsAt && mode === 'countdown') {
      setDays(Math.max(0, diffInDays(new Date(), endsAt)))
    }
  }, [endsAt, mode])

  if (!endsAt) return null

  let label: ReactNode
  if (mode === 'countdown' && days !== undefined) {
    label = intl.formatMessage(
      {
        id: 'tYcAyPPiTJDUicN_oM4j',
        defaultMessage: 'Active for {days, plural, one {# day} other {# days}}',
        description: 'Remaining active days of the chosen reward in the double rewards landing page hero',
      },
      { days },
    )
  } else {
    label = intl.formatMessage(
      {
        id: 'yuV1za4gSaYBrdgYmPZH',
        defaultMessage: 'Active until {date}',
        description: 'Expiry label for the selected double reward on the campaign landing page',
      },
      { date: <FormatDateTime value={endsAt} day="numeric" month="short" /> },
    )
  }

  return <HighlightLabel>{label}</HighlightLabel>
}

export default LoyaltyChooseDoubleRewardsLandingPageActiveLabel
